import { divIcon } from "leaflet";
import { renderToStaticMarkup } from "react-dom/server";

export const createCustomMarkerIcon = () => {
  return divIcon({
    html: renderToStaticMarkup(
      <i
        style={{ color: "rgb(46, 50, 51, 1)" }}
        className="fas fa-map-marker-alt fa-1x"
      />
    ),
  });
};
